/** «Зміна стану ОЗ/НМА» (0444, 2026-08-29): консервація / ремонт / повернення / строк. */
import { api } from './client';
import type { Page } from './catalogs';

export type ChangeKind = 'CONSERVATION' | 'REPAIR_LONG' | 'OPERATING' | 'USEFUL_LIFE' | 'DEPR_PARAMS';
export const CHANGE_KIND_UA: Record<ChangeKind, string> = {
  CONSERVATION: 'консервація', REPAIR_LONG: 'тривалий ремонт',
  OPERATING: 'повернення в експлуатацію', USEFUL_LIFE: 'зміна строку корисного використання',
  DEPR_PARAMS: 'зміна параметрів амортизації',
};

export interface AssetStateChange {
  id: string; organization_id: string; document_number: string; document_date: string;
  posted: boolean; posted_at: string | null; deletion_mark: boolean; comment: string | null;
  change_kind: ChangeKind; asset_kind: 'FIXED_ASSET' | 'INTANGIBLE';
  fixed_asset_id: string | null; intangible_asset_id: string | null;
  effective_date: string; reason: string | null; new_useful_life_months: number | null;
  new_depreciation_method_id: string | null; new_liquidation_value: string | null;
  prev_status: string | null; prev_useful_life_months: number | null;
  prev_depreciation_method_id: string | null; prev_liquidation_value: string | null;
  external_source?: string | null; created_at: string; updated_at: string;
}
export interface AssetStateChangeCreate {
  organization_id: string; document_number?: string | null; document_date: string;
  change_kind: ChangeKind; asset_kind: 'FIXED_ASSET' | 'INTANGIBLE';
  fixed_asset_id?: string | null; intangible_asset_id?: string | null;
  effective_date: string; reason?: string | null; new_useful_life_months?: number | null;
  new_depreciation_method_id?: string | null; new_liquidation_value?: string | null;
  comment?: string | null;
}
const BASE = '/documents/asset-state-changes';
export const assetStateChange = {
  list: (params?: { organization_id?: string; posted?: boolean; fixed_asset_id?: string; date_from?: string; date_to?: string; limit?: number; offset?: number }) =>
    api.get<Page<AssetStateChange>>(BASE, { params }).then((r) => r.data),
  get: (id: string) => api.get<AssetStateChange>(`${BASE}/${id}`).then((r) => r.data),
  create: (p: AssetStateChangeCreate) => api.post<AssetStateChange>(BASE, p).then((r) => r.data),
  update: (id: string, p: Partial<AssetStateChangeCreate>) => api.patch<AssetStateChange>(`${BASE}/${id}`, p).then((r) => r.data),
  remove: (id: string) => api.delete(`${BASE}/${id}`).then(() => undefined),
  post: (id: string) => api.post<AssetStateChange>(`${BASE}/${id}/post`).then((r) => r.data),
  unpost: (id: string) => api.post<AssetStateChange>(`${BASE}/${id}/unpost`).then((r) => r.data),
};
